module.exports = __webpack_public_path__ + "static/media/ypsilibrary3.5ae7fd32.jpg";